import { create } from "zustand";

export interface BeforeInstallPromptEvent extends Event {
	prompt(): Promise<void>;
	readonly userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
}

type PwaState = {
	installPrompt: BeforeInstallPromptEvent | null;
	isInstalled: boolean;
};

type PwaActions = {
	setInstallPrompt: (event: BeforeInstallPromptEvent) => void;
	triggerInstall: () => void;
	setInstalled: () => void;
};

export const usePwaStore = create<PwaState & PwaActions>((set, get) => ({
	installPrompt: null,
	isInstalled: false,
	setInstallPrompt: (event) => set({ installPrompt: event }),
	triggerInstall: () => {
		const { installPrompt } = get();
		if (!installPrompt) return;
		installPrompt.prompt();
		set({ installPrompt: null });
	},
	setInstalled: () => set({ isInstalled: true, installPrompt: null }),
}));
